import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSection } from './components/PainSection';
import { SystemRevealSection } from './components/SystemRevealSection';
import { IncludesSection } from './components/IncludesSection';
import { FormatsSection } from './components/FormatsSection';
import { EbookCarouselSection } from './components/EbookCarouselSection';
import { MidPageCta } from './components/MidPageCta';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { ComparisonSection } from './components/ComparisonSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingCtaSection } from './components/ClosingCtaSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-charcoal-950 pb-20 font-sans text-body lg:pb-0" data-id="element-0" data-mp="3rcsy3udgkeef">
      <Hero data-id="element-1" data-mp="4wv3njt0sf7" />

      <main data-id="element-2" data-mp="4n7g6m8exco">
        <TestimonialsSection data-id="element-3" data-mp="56n1goet9nj" />
        <PainSection data-id="element-4" data-mp="2zl3brl12165b" />
        <SystemRevealSection data-id="element-5" data-mp="2zllijblcf2rh" />
        <IncludesSection data-id="element-6" data-mp="2zmo557bmuj1l" />
        <FormatsSection data-id="element-7" data-mp="2zn678kkz7rhf" />
        <EbookCarouselSection data-id="element-8" data-mp="33mf0loc3tncg" />
        <MidPageCta data-id="element-9" data-mp="33nq921ghvj9w" />
        <BonusesSection data-id="element-10" data-mp="33mymth8sexwa" />
        <OfferSection data-id="element-11" data-mp="33oi0d0326uud" />
        <TestimonialsSection variant="compact" id="proof-2" data-id="element-12" data-mp="38l8gfnev5qfs" />
        <ComparisonSection data-id="element-13" data-mp="38nupxslbeg0n" />
        <GuaranteeSection data-id="element-14" data-mp="3dkl6eh117dml" />
        <FaqSection data-id="element-15" data-mp="3dlw4q1bpjt6b" />
        <ClosingCtaSection data-id="element-16" data-mp="3dmfmni1cyhkc" />
        <FinalOfferSection data-id="element-17" data-mp="3dii716dzo857" />
      </main>

      <Footer data-id="element-18" data-mp="nuhgse7ce3s6" />
      <StickyCta data-id="element-19" data-mp="nuraabrlit2m" />
      <PurchaseToast data-id="element-20" data-mp="nvan5e2e2r9s" />
    </div>;
}